<template>
	<div class="modal fade" id="huskyCardModal" tabindex="-1" role="dialog" aria-labelledby="huskyCardModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="huskyCardModalLabel">How do I find my Student Number?</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<p>Your student number is printed at the bottom of your Husky Card.</p>
					<br/>
					<!-- <img src="./img/dubs_image.jpg" alt="Image of Husky Card"/> -->
					<img src="https://apps.osfa.washington.edu/kiosk/img/dubs_image.jpg" alt="Image of Husky Card"/>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    // import Navigation from './Navigation.vue'
    export default {
        name: 'HuskyCardModal',
        components: {
        },
        data: function() {
            return {
            }
        },
        props: {
        },
        created: function() {
        }
    }
</script>

<style scoped>
	.modal-dialog {
		box-shadow: 0 0 40px -10px #333;
	}

	img {
		width:100%;
	}
</style>
